// Recently viewed products (snippets/recently-viewed.liquid). Handles are kept in this
// browser's localStorage only. Each visit fetches the product's live JSON, so price and stock
// are current; products that no longer exist are dropped from the list.
const KEY = 'hps-recently-viewed';
const MAX_STORED = 12;
const MAX_SHOWN = 6;

function load() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
  } catch {
    return [];
  }
}
function save(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch { /* storage full or blocked */ }
}

class SRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const current = this.dataset.current || '';
    const stored = load();
    const others = stored.filter((h) => h !== current).slice(0, MAX_SHOWN);
    if (current) save([current, ...stored.filter((h) => h !== current)]);

    this.querySelector('[data-clear]')?.addEventListener('click', () => {
      save(current ? [current] : []);
      this.hidden = true;
    });
    if (!others.length) return;

    const root = this.dataset.root || '/';
    const money = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
    const results = await Promise.all(others.map((h) =>
      fetch(`${root.replace(/\/$/, '')}/products/${encodeURIComponent(h)}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));

    const gone = others.filter((h, i) => !results[i]);
    if (gone.length) save(load().filter((h) => !gone.includes(h)));

    const list = this.querySelector('[data-list]');
    const tpl = this.querySelector('template[data-item]');
    if (!list || !tpl) return;
    for (const p of results) {
      if (!p) continue;
      const node = tpl.content.cloneNode(true);
      const link = node.querySelector('[data-link]');
      link.href = p.url;
      node.querySelector('[data-title]').textContent = p.title;
      node.querySelector('[data-price]').textContent = p.available ? money.format(p.price / 100) : this.dataset.soldOut;
      const img = node.querySelector('[data-img]');
      if (p.featured_image) {
        const src = p.featured_image.startsWith('//') ? `https:${p.featured_image}` : p.featured_image;
        img.src = `${src}${src.includes('?') ? '&' : '?'}width=300`;
      } else {
        img.remove();
        node.querySelector('[data-noimg]').hidden = false;
      }
      list.append(node);
    }
    if (list.children.length) this.hidden = false;
  }
}
if (!customElements.get('s-recently-viewed')) customElements.define('s-recently-viewed', SRecentlyViewed);
